import { displayRate } from '../util';
import { EstateStatusItemState } from '../generated/graphql';
import { ESTATE_STATUS_PERCENT_SCALE, ESTATE_STATUS_SCORE_DECIMAL_MULTIPLIER } from './constants';
import {
  EstateStatusAttachmentLink,
  EstateStatusChecklistItem,
  EstateStatusReadOnlyChecklistItem,
  EstateStatusSummary,
} from './types';

function cloneEstateStatusAttachmentLinks(attachmentLinks: EstateStatusAttachmentLink[] | undefined | null) {
  return (attachmentLinks ?? []).map((attachmentLink) => ({ ...attachmentLink }));
}

function cloneEstateStatusChecklistItem(item: EstateStatusChecklistItem): EstateStatusChecklistItem {
  return {
    ...item,
    note: item.note ?? '',
    lastReviewedAt: item.lastReviewedAt ?? null,
    attachmentLinks: cloneEstateStatusAttachmentLinks(item.attachmentLinks),
  };
}

export function cloneEstateStatusChecklist(checklist: EstateStatusChecklistItem[]) {
  return checklist.map(cloneEstateStatusChecklistItem);
}

export function calculateEstateStatusSummary(checklist: EstateStatusReadOnlyChecklistItem[]): EstateStatusSummary {
  const completed = checklist.reduce((sum, item) => sum + (item.state === EstateStatusItemState.Yes ? 1 : 0), 0);
  const applicable = checklist.reduce((sum, item) => sum + (item.state === EstateStatusItemState.Na ? 0 : 1), 0);
  const total = checklist.length;
  const totalWeight = checklist.reduce((sum, item) => sum + item.weight, 0);
  const applicableWeight = checklist.reduce(
    (sum, item) => sum + (item.state === EstateStatusItemState.Na ? 0 : item.weight),
    0
  );
  const earnedWeight = checklist.reduce(
    (sum, item) => sum + (item.state === EstateStatusItemState.Yes ? item.weight : 0),
    0
  );
  let score: number | null = null;

  if (applicableWeight > 0) {
    const rawScorePercent = (earnedWeight / applicableWeight) * ESTATE_STATUS_PERCENT_SCALE;
    score =
      Math.round(rawScorePercent * ESTATE_STATUS_SCORE_DECIMAL_MULTIPLIER) / ESTATE_STATUS_SCORE_DECIMAL_MULTIPLIER;
  }

  return {
    completed,
    applicable,
    total,
    earnedWeight,
    applicableWeight,
    totalWeight,
    score,
  };
}

export function formatEstateStatusWeight(value: number) {
  return displayRate(value / ESTATE_STATUS_PERCENT_SCALE, { zeroIsDash: false });
}
